export interface ICapabilityValue {
  capability: string;
  value: CapabilityValue;
  reason?: string;
}

export enum CapabilityValue {
  Allowed = 'allowed',
  Denied = 'denied',
  Mixed = 'mixed',
  Unspecified = 'unspecified'
}
